import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Badge, OverlayTrigger } from "react-bootstrap";
import { StandardCode } from "./lesson-information-modal-types";
import { getStandard } from "./standards";
import "./standards.scss";

interface IStandardsProp {
  standardData: string;
  standardCodes: StandardCode[];
  mpngStyle?: boolean;
}
const Standard = (props: IStandardsProp) => {
  const { standardData, standardCodes, mpngStyle = true } = props;
  const standardRef = useRef(null);
  const [bottomStart, setBottomStart] = useState(false);

  useLayoutEffect(() => {
    const leftBound = 244;

    if (standardRef.current) {
      var standardLeft = standardRef.current.getBoundingClientRect().left;

      if (standardLeft <= leftBound) {
        setBottomStart(true);
      }
    }
  }, []);

  useEffect(() => {
    if (mpngStyle && standardRef.current) {
      standardRef.current.style.setProperty("--standard-badge-primary-color", "var(--mps-component-library-mpng-blue)");
      standardRef.current.style.setProperty("--standard-badge-accent-color", "var(--mps-component-library-mpng-accent-blue)");
    }
  }, [mpngStyle]);

  return (
    <div ref={standardRef} className="standard-badge-container" data-testid="standard-badge-container">
      <OverlayTrigger
        data-testid="abld-tile-standard-overlay"
        placement={bottomStart ? "bottom-start" : "bottom"}
        overlay={getStandard(standardData as string, standardCodes)}
      >
        <Badge className={"standardBadge"} data-testid="abld-tile-standard-test-id">
          {standardData}
        </Badge>
      </OverlayTrigger>
    </div>
  );
};

export default Standard;
